/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button } from '@material-ui/core';
import styled from 'styled-components/macro';
import { openTab } from '../../utils/open-tab';

const SButton = styled(Button)`
  font-size: 16px;
  background: #eb0053;
`;

export const MahButton: React.FC<{ url: string }> = ({ url, ...props }) => (
  <SButton
    color="secondary"
    variant="contained"
    onClick={(e) => openTab(e, url)}
    {...props}
  >
    Kjøp nå
  </SButton>
);
